<script setup>
import ChevronDownIcon from '~/assets/icons/chevron-down.svg'

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  renderAsHtml: {
    type: Boolean,
    default: false,
  },
  maxHeight: {
    type: String,
    default: '168px',
  },
  customTextStyle: {
    type: Object,
    default: () => ({}),
  },
})

const maskImage = ref('linear-gradient(to bottom, #000 65%, transparent 100%)')
const showBtn = ref(true)
const transition = 'all 0.3s ease-out'
const maxHeight = toRef(props, 'maxHeight')
const height = ref(maxHeight.value)

function onClick() {
  height.value = '10000px'
  maskImage.value = 'linear-gradient(to bottom, #000 100%, transparent 0%)'
  showBtn.value = false
}
</script>

<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="expandable-text">
    <div
      :style="{ maskImage, '-webkit-mask-image': maskImage, transition }"
      data-testid="expandable-text"
    >
      <div
        v-if="renderAsHtml"
        class="overflow-hidden mb-0 text-pre-line"
        :style="{ maxHeight: height, transition, ...customTextStyle }"
        v-html="text"
      />
      <p
        v-else
        class="overflow-hidden mb-0 text-pre-line"
        :style="{ maxHeight: height, transition }"
      >
        {{ text }}
      </p>
    </div>
    <BaseButton
      v-if="showBtn"
      id="gtm-track"
      variant="link"
      class="read-more-btn reset-btn-styling"
      @click="onClick"
    >
      <ChevronDownIcon class="chevron-down-icon" />
      {{ $label('common.readMore') }}
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
.read-more-btn {
  text-decoration: none;
  margin-top: -10px;
  padding-top: 16px;
  padding-left: 6px;
}

.chevron-down-icon {
  fill: $bc-green;
  margin-right: 9px;
}
</style>
